export default "__VITE_ASSET__BFA5YgVY__ 584w";